import { createStore } from 'effector';
import { loginFx } from '@buildex/core';

export const $loginError = createStore<boolean>(false)
  .on(loginFx.failData, () => true)
  .reset(loginFx);

export const $loginPending = loginFx.pending;
